module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "line-height-20 margin-t30"
  }, [_vm._v("\n    Para recarregar é necessário informar um valor de recarga. O valor mínimo\n    por recarga é " + _vm._s(_vm._f("cents")(_vm.unit)) + ". Você pode\n    escolher quantos múltiplos de " + _vm._s(_vm._f("cents")(_vm.unit)) + " que quiser (quanto maior\n    o valor, menor será a taxa de recarga).\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "col-xs-12"
  }, [_c('form', {
    attrs: {
      "id": "form-recarga",
      "action": "index.html",
      "method": "post",
      "data-toggle": "validator"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.duplicityCheck.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "box margin-20 box-content-padding"
  }, [_c('div', {
    staticClass: "alert alert-danger text-center",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "error-recharge"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Valor recarga")]), _vm._v(" "), (_vm.planId != 70 && _vm.planId != 71) ? _c('div', {
    staticClass: "row margin-t5"
  }, [_c('btn-recharge-value', {
    staticClass: "small-padding-right",
    attrs: {
      "unit": 1,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-right small-padding-left",
    attrs: {
      "unit": 2,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-right small-padding-left",
    attrs: {
      "unit": 10,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-left",
    attrs: {
      "unit": 20,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.numeroDeVeiculos && (_vm.planId == 70 || _vm.planId == 71)) ? _c('div', {
    staticClass: "row margin-t5"
  }, [_c('btn-recharge-value', {
    staticClass: "small-padding-right",
    attrs: {
      "unit": 1,
      "roadCardUnit": _vm.numeroDeVeiculos,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-right small-padding-left",
    attrs: {
      "unit": 2,
      "roadCardUnit": _vm.numeroDeVeiculos,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-right small-padding-left",
    attrs: {
      "unit": 10,
      "planId": _vm.planId,
      "roadCardUnit": _vm.numeroDeVeiculos
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  }), _vm._v(" "), _c('btn-recharge-value', {
    staticClass: "small-padding-left",
    attrs: {
      "unit": 20,
      "roadCardUnit": _vm.numeroDeVeiculos,
      "planId": _vm.planId
    },
    on: {
      "increment": _vm.incrementTotal,
      "valoresRecebidos": _vm.valoresRecebidos
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': _vm.errors.has('valueTotal')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|valorRecarga:' + _vm.unit),
      expression: "'required|valorRecarga:' + unit"
    }],
    staticClass: "form-control text-right input-recharge",
    attrs: {
      "id": "valueTotal",
      "type": "text",
      "name": "valueTotal",
      "placeholder": "R$ 00,00",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off"
    },
    domProps: {
      "value": _vm.valueFormatted
    },
    on: {
      "input": function($event) {
        return _vm.setTotal($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "errorMessage"
  }, [_c('span', {
    staticClass: "mensagem"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "help-block help-block-recharge with-errors"
  }, [_vm._v("\n                " + _vm._s(_vm.errors.first("valueTotal")) + "\n              ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loadingRates),
      expression: "loadingRates"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "recharge-summary-box"
  }, [_c('p', [_vm._v("\n                  Valor da taxa"), _c('span', {
    staticClass: "rate-value pull-right bold"
  }, [_vm._v(_vm._s(_vm.tax))])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-rule"
  }), _vm._v(" "), _c('p', [_vm._v("\n                  Valor total"), _c('span', {
    staticClass: "total-value pull-right bold"
  }, [_vm._v(_vm._s(_vm.total))])])]), _vm._v(" "), _vm._m(0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-info margin-b20"
  }, [_c('small', [_vm._v("Esse valor que será debitado uma única vez na sua conta\n                  corrente, cartão de crédito ou no pagamento do boleto\n                  bancário.")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0c73e4ce!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/recharge/recharge-multiple.vue
// module id = 2044
// module chunks = 1